import InfoModel from './InfoModel.js' 
import store from 'store/store.js';
import Info from './Info.js'
import Vue from 'vue';
import Component from 'vue-class-component';


@Component
export default class InfoContainer extends Vue {
    constructor() {
        super();
        this.items = this.getInfo();
        
    }

    getFullName(){
        return InfoModel.getFullName();
    }

    getInfo(){
        InfoModel.empListData();
        let p = store.getters.empList;
        
        return p;
    }

    render(h) {
        return (
            <div>
                <Info container={this} items={this.items} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Info/InfoContainer.js